<script setup lang="ts">
  import { computed, onMounted } from 'vue';
  import ContactFormContainer from '../components/ContactFormContainer.vue';
  import ContactFormResult from '../components/ContactFormResult.vue';
  import ContactFormLoading from '../components/ContactFormLoading.vue';
  import { useContactFormStore } from '../store/contactFormStore';
  import { useInitialiseForm } from '../hooks/useInitialiseForm';
  import { useInitialiseContactList } from '../hooks/useInitialiseContactList';

  interface ContactFormProps {
    query: string;
    folder: string;
  };

  const props = defineProps<ContactFormProps>();
  const { fetchFormData } = useInitialiseForm(props.query, props.folder);
  const contactFormStore = useContactFormStore();

  useInitialiseContactList();

  onMounted(() => {
    fetchFormData();
  });

  const formItem = computed(() => contactFormStore.getFirstFormItem);
  const showForm = computed(() => contactFormStore.showForm);
  const showResult = computed(() => contactFormStore.showResult);
  const showSuccess = computed(() => contactFormStore.showSuccessMessage);
  const showError = computed(() => contactFormStore.showFailureMessage);
  const showLoading = computed(() => !contactFormStore.dataReady && !contactFormStore.hasError);
</script>

<template>
   <div class="contact-us-vue-page">
    <contact-form-loading v-if="showLoading" />
    <contact-form-container
      v-if="showForm && formItem"
      :formItem="formItem"
    />
    <contact-form-result
      v-if="showResult && formItem"
      :formItem="formItem"
      :showSuccess="showSuccess"
      :showError="showError"
    />
  </div>
</template>

<style lang="scss" scoped>
  .contact-us-vue-page {
    max-width: 550px;
    margin: 0 auto;
  } 
</style>